if (TARGET === 'discord') {
    const addProxy = (url) => {
        const split = url.split('/');

        const proxyIndex = url.includes('://') ? 3 : split[0] !== '' ? 0 : 1;
        if (split.length <= proxyIndex) {
            return url;
        }
        if (split[proxyIndex] !== '.proxy' && split[proxyIndex] !== '') {
            split.splice(proxyIndex, 0, '.proxy');
            return split.join('/');
        }
        return url;
    };

    const originalFetch = window.fetch;

    window.fetch = (param1, param2) => {
        if (typeof param1 === 'string') {
            return originalFetch(addProxy(param1), param2);
        }
        return originalFetch(param1, param2);
    };
}

/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 *     - `wle:auto-constants:start` and `wle:auto-constants:end`: The project's constants,
 *        such as the project's name, whether it should use the physx runtime, etc...
 *     - `wle:auto-benchmark:start` and `wle:auto-benchmark:end`: Append the benchmarking code
 */
import {Vrm, WasdControlsComponent} from '@wonderlandengine/components';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {FingerCursor} from '@wonderlandengine/components';
import {HandTracking} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {TeleportComponent} from '@wonderlandengine/components';
import {Trail} from '@wonderlandengine/components';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {AudioListener} from '@wonderlandengine/spatial-audio';
import {AudioSource} from '@wonderlandengine/spatial-audio';
import {BulletPool} from './bullet-pool.js';
import {Bullet} from './bullet.js';
import {ButtonComponent} from './button.js';
import {CopyRotation} from './copy-rotation.js';
import {Flag} from './flag.js';
import {IsolateParentRotation} from './isolate-parent-rotation.js';
import {Leaderboard} from './leaderboard.js';
import {PaintballClient} from './paintball-client.js';
import {SmoothLocomotion} from './player-controller.js';
import {CharacterLibrary, RegisterCharacter} from './register-character.js';
import {StartGameButton} from './start-game-button.js';
import {TimeoutScreen} from './timeout-screen.js';
import {TimeoutSign} from './timeout-sign.js';
import {Timer} from './timer.js';
import {InputField} from './input-field.js';
import {ButtonPlay} from './button-play.js';
import {ButtonShare} from './button-share.js';
import {ShootingTarget} from './shooting-target.ts';
import {ParticleSystem} from './particle-system.ts';

import {loadRuntime} from '@wonderlandengine/api';
import {CopyRotationSwitchOther} from './copy-rotation-switch-other.js';
import {NameModal} from './name-modal.js';
import {RewardScreen} from './reward-screen.js';
import {Config} from './config.js';
import {ErrorSeverity} from './game-analytics-enums.js';
import {MenuPanel} from './menuPanel.tsx';
import {RewardScreenUi} from './rewardScreenUi.tsx';
import {TargetShootingPanel} from './targetShootingPanel.ts';
import {WatchUI} from './watchUi.tsx';
import {MuteButton} from './mute-button.js';
import {Vignette} from './vignette.ts';

import {Vrm0} from './components/vrm.js';
import {PaintballVrmIk} from './paintball-vrm-ik.js';
import {Head} from './head.js';
import {TwoJointIkSolver} from '@wonderlandengine/components';
import {Crosshair} from './crosshair.ts';

import {saveGame, leaderboards, user, purchases} from 'uber-sdk';
import {CookieSaveGameProvider} from 'uber-sdk/providers/cookie.js';
import {HeyVRProvider} from 'uber-sdk/providers/heyVR.js';
import {DiscordActivityProvider} from 'uber-sdk/providers/discord.js';
import {ViverseProvider} from 'uber-sdk/providers/viverse.js';

import {version} from '../package.json';

if (!WL_EDITOR) {
    const ga = require('gameanalytics');
    window.GameAnalytics = ga.GameAnalytics;
    GameAnalytics.setEnabledInfoLog(true);
    const GA_GAME_KEY = '550d87469afbed2b75d3c931cfd0d177';
    const GA_SECRET_KEY = 'd99251fb4db3e2dd43b8ad962f6afce652a62e60';
    GameAnalytics.initialize(GA_GAME_KEY, GA_SECRET_KEY);
    GameAnalytics.configureBuild(TARGET + ' ' + version);

    ga.GameAnalytics.addRemoteConfigsListener({
        onRemoteConfigsUpdated: () => {
            /**
             * A/B Testing will allow us to remote-control variations of
             * the game and measure change in engangement, revenue and
             * other metrics.
             */
            const all = ga.GameAnalytics.getRemoteConfigsContentAsString();
            const configs = JSON.parse(all);
            console.log('Received remote config.');
            for (let [k, v] of Object.entries(configs)) {
                if (k in Config) {
                    try {
                        if (typeof Config[k] === 'number') {
                            v = Number.parseFloat(v);
                        }
                        Config[k] = v;
                    } catch (e) {
                        GameAnalytics.addErrorEvent(
                            ErrorSeverity.Error,
                            `Unable to apply config "${k}" with value "${v}":` +
                                e.toString()
                        );
                    }
                }
            }
        },
    });
    /* if we are building for a discord activity, register the user provider*/
    if (TARGET === 'discord') {
        try {
            const discordProvider = new DiscordActivityProvider({
                DISCORD_CLIENT_ID: '1330737995132964906',
                DISCORD_APPLICATION_ID: '1330737995132964906',
            });
            user.registerProvider(discordProvider);
        } catch (e) {
            /* Local debugging */
        }
    }

    if (TARGET === 'viverse') {
        const viverse = new ViverseProvider({
            clientId: 'd94bb88b-e79c-4870-bc27-5cd9a434a1e3',
            clientName: 'Wonderland Engine',
        });
        user.registerProvider(viverse);
    }

    saveGame.registerProvider(new CookieSaveGameProvider());

    if (TARGET === 'heyvr') {
        const heyVR = new HeyVRProvider('paintball', /* debug? */ false);
        saveGame.registerProvider(heyVR);
        leaderboards.registerProvider(heyVR);
        purchases.registerProvider(heyVR);
        user.registerProvider(heyVR);
    }
}

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'Paintball - Viverse',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['local','local-floor','hand-tracking','hit-test',],
};
const RuntimeOptions = {
    physx: true,
    loader: true,
    xrFramebufferScaleFactor: 1,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

const engine = await loadRuntime(
    (TARGET === 'discord' ? '/.proxy/' : '') + Constants.RuntimeBaseName,
    RuntimeOptions
);
engine.erasePrototypeOnDestroy = true;

/* WebXR setup. */

function requestSession(mode) {
    engine
        .requestXRSession(
            mode,
            Constants.WebXRRequiredFeatures,
            Constants.WebXROptionalFeatures
        )
        .catch((e) => console.error(e));
}

function setupButtonsXR() {
    /* Setup AR / VR buttons */
    const arButton = document.getElementById('ar-button');
    if (arButton) {
        arButton.dataset.supported = engine.arSupported;
        arButton.addEventListener('click', () => requestSession('immersive-ar'));
    }
    const vrButton = document.getElementById('vr-button');
    if (vrButton) {
        vrButton.dataset.supported = engine.vrSupported;
        vrButton.addEventListener('click', () => requestSession('immersive-vr'));
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('load', setupButtonsXR);
} else {
    setupButtonsXR();
}
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(FingerCursor);
engine.registerComponent(HandTracking);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(TeleportComponent);
engine.registerComponent(Trail);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(AudioListener);
engine.registerComponent(AudioSource);
engine.registerComponent(BulletPool);
engine.registerComponent(Bullet);
engine.registerComponent(ButtonComponent);
engine.registerComponent(CopyRotation);
engine.registerComponent(Flag);
engine.registerComponent(IsolateParentRotation);
engine.registerComponent(Leaderboard);
engine.registerComponent(PaintballClient);
engine.registerComponent(SmoothLocomotion);
engine.registerComponent(RegisterCharacter);
engine.registerComponent(StartGameButton);
engine.registerComponent(TimeoutScreen);
engine.registerComponent(TimeoutSign);
engine.registerComponent(CharacterLibrary);
engine.registerComponent(InputField);
engine.registerComponent(ButtonPlay);
engine.registerComponent(CopyRotationSwitchOther);
engine.registerComponent(NameModal);
engine.registerComponent(RewardScreen);
engine.registerComponent(Timer);
engine.registerComponent(ButtonShare);
engine.registerComponent(MenuPanel);
engine.registerComponent(RewardScreenUi);
engine.registerComponent(WatchUI);
engine.registerComponent(MuteButton);
engine.registerComponent(Vignette);
engine.registerComponent(ShootingTarget);
engine.registerComponent(ParticleSystem);
engine.registerComponent(TargetShootingPanel);
engine.registerComponent(PaintballVrmIk);
engine.registerComponent(Head);
engine.registerComponent(TwoJointIkSolver);
engine.registerComponent(Crosshair);

if (TARGET === 'viverse') {
    engine.registerComponent(Vrm0);
}

try {
    await engine.loadMainScene(
        `${TARGET === 'discord' ? '/.proxy/' : ''}${Constants.ProjectName}.bin`
    );
    const el = document.getElementById('version');
    if (el) setTimeout(() => el.remove(), 2000);
} catch (e) {
    console.error(e);
    GameAnalytics.addErrorEvent(
        ErrorSeverity.Critical,
        `Failed to load ${Constants.ProjectName}.bin:` + e.toString()
    );
    window.alert(`Failed to load ${Constants.ProjectName}.bin:`, e);
}

window.onerror = (e) => {
    GameAnalytics.addErrorEvent(ErrorSeverity.Error, `Uncaught exception:` + e.toString());
    /* Default handling for developers */
    return false;
};

/* wle:auto-benchmark:start */
/* wle:auto-benchmark:end */

/* wle:migration:1.3.0:js/prototype-map-migrated-index.js:PrototypeMap-components.js:PrototypeMap-bundle.js */
